var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWithdrawIc1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9172 86.5376C30.0069 86.2166 29.1004 85.8656 28.1989 85.4842C5.07286 75.7 -5.98932 49.6035 3.49085 27.196C12.971 4.78856 39.4036 -5.44461 62.5297 4.33959C63.4316 4.7212 64.3153 5.12762 65.18 5.55767C66.0904 5.8787 66.9968 6.22968 67.8983 6.61107C91.0244 16.3953 102.087 42.4918 92.6064 64.8992C83.1262 87.3067 56.6936 97.5399 33.5676 87.7557C32.6656 87.3741 31.782 86.9676 30.9172 86.5376Z",
    fill: "#FFC423"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2458 88.2057C56.6533 97.6859 82.5033 87.2062 91.9835 64.7988C101.464 42.3913 90.984 16.5413 68.5765 7.0611C46.1691 -2.41908 20.319 8.06057 10.8389 30.468C1.35869 52.8755 11.8383 78.7255 34.2458 88.2057Z",
    fill: "url(#paint0_linear_1_175)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9001 84.9389C49.3076 94.419 75.1576 83.9394 84.6378 61.5319C94.118 39.1245 83.6383 13.2744 61.2308 3.79425C38.8234 -5.68592 12.9733 4.79372 3.49316 27.2012C-5.98701 49.6087 4.49263 75.4587 26.9001 84.9389Z",
    fill: "url(#paint1_linear_1_175)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0484 41.7162C87.0617 25.5478 77.1601 10.5341 61.2297 3.79425C45.502 -2.85983 28.0783 0.319409 15.8096 10.5546C14.1571 29.1658 23.4556 46.9382 40.2246 54.0329C56.8196 61.0539 75.8253 55.5419 88.0484 41.7162Z",
    fill: "#FFDB16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7445 73.4957C47.8319 80.302 66.3909 72.7782 73.1972 56.6908C80.0035 40.6033 72.4796 22.0444 56.3922 15.2381C40.3048 8.4318 21.7458 15.9556 14.9396 32.043C8.13328 48.1305 15.6571 66.6895 31.7445 73.4957Z",
    fill: "url(#paint2_linear_1_175)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6189 71.4053C47.5573 77.7255 64.7906 70.739 71.1107 55.8007C77.4308 40.8624 70.4444 23.6291 55.5061 17.3089C40.5678 10.9888 23.3344 17.9753 17.0143 32.9136C10.6942 47.8519 17.6806 65.0852 32.6189 71.4053Z",
    fill: "#FF9900"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.523 52.0382L63.9393 33.6415L52.7268 33.6415L48.3983 31.4714L43.8414 30.3255L36.4193 21.1352L26.0055 38.2507C24.5571 40.6312 23.86 43.3931 24.0051 46.1759C24.2212 50.319 26.2822 54.1474 29.6217 56.6091L33.0209 59.1149C35.2486 60.757 37.863 61.7954 40.6103 62.1293L44.3429 62.583C48.3541 63.0706 52.3788 61.7869 55.367 59.067C57.4254 57.1934 58.8733 54.7446 59.523 52.0382Z",
    fill: "url(#paint3_linear_1_175)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.213,
    cy: 42.0166,
    r: 2.67586,
    fill: "#F98F00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.1275,
    cy: 48.4313,
    r: 2.67586,
    fill: "#F98F00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_175",
    x1: 83.4493,
    y1: 22.199,
    x2: 91.9833,
    y2: 64.7992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_175",
    x1: 28.3229,
    y1: 32.3709,
    x2: 23.5063,
    y2: 88.0287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF16E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_175",
    x1: 54.0131,
    y1: 15.2459,
    x2: 37.9579,
    y2: 73.0444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD14D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_175",
    x1: 43.9628,
    y1: 21.1352,
    x2: 43.9628,
    y2: 62.6846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBDE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawIc1);
export default __webpack_public_path__ + "static/media/withdraw_ic1.eb58b08568639d02a00abf31ef0604c6.svg";
export { ForwardRef as ReactComponent };